"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
/*
 * Copyright (c) 2022, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * @internal
 */
const readValue = key => {
  // TODO: Use detectLocalStorageAvailable when app can better handle clients without storage
  if (typeof window === 'undefined') {
    return null;
  }
  return window.localStorage.getItem(key);
};

/**
 * @internal
 */
const subscribeToLocalStorage = callback => {
  window.addEventListener('storage', callback);
  return () => window.removeEventListener('storage', callback);
};

/**
 * @internal
 */
const getLocalStorageServerSnapshot = () => {
  // local storage is not available on the server
  return null;
};

/**
 * @internal
 */
function useLocalStorage(key) {
  const getLocalStorageSnapshot = () => readValue(key);
  const store = (0, _react.useSyncExternalStore)(subscribeToLocalStorage, getLocalStorageSnapshot, getLocalStorageServerSnapshot);
  return store;
}
var _default = exports.default = useLocalStorage;